import { gql } from 'apollo-boost'

const NEW_ROOM = gql`
	mutation NEW_ROOM($code: String!, $id: String!) {
		new_room(code: $code, id: $id)
	}
`

const JOIN_ROOM = gql`
	mutation JOIN_ROOM($code: String!, $id: String!) {
		join_room(code: $code, id: $id)
	}
`

const CLEAR_ROOM = gql`
	mutation CLEAR_ROOM($code: String!) {
		clear_room(code: $code)
	}
`

export { NEW_ROOM, JOIN_ROOM, CLEAR_ROOM }
